import { render } from "./PersianDateField.vue?vue&type=template&id=a8a40158"
import script from "./PersianDateField.vue?vue&type=script&lang=js"
export * from "./PersianDateField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PersianDateField.vue"]])

export default __exports__